if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');

        // Next10 — bolinhas do celular (snippets/product-media-gallery.liquid).
        // Ficam antes do "return" abaixo para funcionar mesmo sem miniaturas.
        this.elements.dots = this.querySelector('[data-n10-dots]');
        if (this.elements.dots) {
          this.elements.viewer.addEventListener('slideChanged', (event) => {
            this.setActiveDot(event.detail.currentElement.dataset.mediaId);
          });
          this.elements.dots.querySelectorAll('[data-target]').forEach((dot) => {
            dot.addEventListener('click', this.setActiveMedia.bind(this, dot.dataset.target, false));
          });
        }

        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);
        this.syncDots(mediaId);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      // Reconstrói as bolinhas a partir dos slides atuais: na troca de variante o
      // product-info.js insere/remove/reordena <li> da galeria (hide_variants),
      // e as bolinhas renderizadas no Liquid ficariam com ids velhos.
      syncDots(activeId) {
        const dots = this.elements.dots;
        if (!dots) return;
        // Só os <li> da lista: cada slide tem, DENTRO dele, um botão de zoom
        // que também carrega data-media-id (product-thumbnail.liquid). Sem o
        // `>` a contagem dobrava (3 fotos -> 6 bolinhas) e as bolinhas extras
        // nasciam com o id sem o prefixo da section, sem levar a slide nenhum.
        const slides = Array.from(this.elements.viewer.querySelectorAll('.product__media-list > [data-media-id]'));
        const existing = new Map(
          Array.from(dots.querySelectorAll('[data-target]')).map((dot) => [dot.dataset.target, dot])
        );
        const labelModel = (dots.querySelector('[data-target]') || {}).getAttribute?.('aria-label') || '';
        const fresh = slides.map((slide, index) => {
          const id = slide.dataset.mediaId;
          let dot = existing.get(id);
          if (!dot) {
            dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'n10-gal-dots__dot';
            dot.dataset.target = id;
            dot.setAttribute('aria-label', labelModel.replace(/\d+/, index + 1) || String(index + 1));
            dot.addEventListener('click', this.setActiveMedia.bind(this, id, false));
          }
          if (id === activeId) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
          return dot;
        });
        dots.replaceChildren(...fresh);
      }

      setActiveDot(mediaId) {
        if (!this.elements.dots) return;
        this.elements.dots.querySelectorAll('[data-target]').forEach((dot) => {
          if (dot.dataset.target === mediaId) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
